export class KafkaSecurityConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "securityProtocol",
            "baseName": "securityProtocol",
            "type": "KafkaSecurityProtocol",
            "format": ""
        },
        {
            "name": "saslMechanism",
            "baseName": "saslMechanism",
            "type": "KafkaSaslMechanism",
            "format": ""
        },
        {
            "name": "credentialsSecret",
            "baseName": "credentialsSecret",
            "type": "KafkaSecurityConfigCredentialsSecret",
            "format": ""
        },
        {
            "name": "tlsSecret",
            "baseName": "tlsSecret",
            "type": "KafkaSecurityConfigTlsSecret",
            "format": ""
        },
        {
            "name": "skipTlsVerification",
            "baseName": "skipTlsVerification",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaSecurityConfig.attributeTypeMap;
    }
    constructor() {
    }
}
